import React from 'react';
import { MapPin, Phone, Mail, MessageCircle, Clock } from 'lucide-react';
import { schoolInfo } from '../data/mockData';

const ContactSection = () => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Get in <span className="text-blue-600">Touch</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Visit us or reach out to learn more about admissions
          </p>
          <div className="w-24 h-1 bg-yellow-400 mx-auto rounded-full mt-4" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Information */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
            
            {/* Address */}
            <div className="flex items-start space-x-4 bg-blue-50 rounded-2xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <MapPin className="w-6 h-6 text-white" />
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Address</h4>
                <p className="text-gray-700">{schoolInfo.address}</p>
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-start space-x-4 bg-yellow-50 rounded-2xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-yellow-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <Phone className="w-6 h-6 text-white" />
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Phone</h4>
                <a href={`tel:${schoolInfo.phone}`} className="text-gray-700 hover:text-blue-600 transition-colors">
                  {schoolInfo.phone}
                </a>
              </div>
            </div>

            {/* WhatsApp */}
            <div className="flex items-start space-x-4 bg-green-50 rounded-2xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-green-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <MessageCircle className="w-6 h-6 text-white" />
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">WhatsApp</h4>
                <a 
                  href={`https://wa.me/${schoolInfo.whatsapp.replace(/[^0-9]/g, '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-green-600 transition-colors"
                >
                  {schoolInfo.whatsapp}
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start space-x-4 bg-purple-50 rounded-2xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-purple-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <Mail className="w-6 h-6 text-white" />
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Email</h4>
                <a href={`mailto:${schoolInfo.email}`} className="text-gray-700 hover:text-blue-600 transition-colors break-all">
                  {schoolInfo.email}
                </a>
              </div>
            </div>

            {/* Working Hours */}
            <div className="flex items-start space-x-4 bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-gray-700 rounded-xl flex items-center justify-center flex-shrink-0">
                <Clock className="w-6 h-6 text-white" />
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">School Timings</h4>
                <p className="text-gray-700 text-sm">Summer: 9:00 AM – 12:30 PM</p>
                <p className="text-gray-700 text-sm">Winter: 9:30 AM – 1:00 PM</p>
                <p className="text-gray-500 text-xs mt-1">Monday - Saturday</p>
              </div>
            </div>
          </div>

          {/* Google Map */}
          <div className="h-[500px] lg:h-full">
            <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg h-full">
              <iframe
                src={schoolInfo.mapEmbedUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Gyanodeepti School Location"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
